import { GroupType, KindType, MeasurementValueType, PlaceOfUseType, TestEquipmentDevice } from '../backend/backendapi';

export function equipmentNumber(equipment: TestEquipmentDevice, kinds: KindType[], groups: GroupType[], placeofuses: PlaceOfUseType[]): string {
  let kind = kinds.find(e => e.id === equipment.kindId);
  let group = groups.find(e => e.id === equipment.groupId);
  let placeofuse = placeofuses.find(e => e.id === equipment.placeOfUseShortId);

  return placeofuse?.name + '-' + group?.name + '-' + kind?.name + '-' + equipment.itemNo;
}

export function getValue(value: string, type: MeasurementValueType): string | number {
  switch (type) {
    case MeasurementValueType.Float:
      return parseFloat(value);
    case MeasurementValueType.String:
    default:
      return value;
  }
}